/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SystemVersions {
    angular.module("meevo.plugins.systemVersions", []);
}